import React, { useState } from "react"
import "./card-samples.scss"
import FormatDate from "../../../shared/utils/formartDate"

const CardSamples = ({ info }) => {


  const [isShow, setIsShow] = useState(false)
  // console.log(btnActive)
  const handleHide = (e) => {
    // e.preventDefault();
    setIsShow(!isShow)
  }

  return (
    <div className="f-card-samples" onClick={e => handleHide(e)}>
      <div className="f-card-samples__img">
        <img className="f-img"
             src={"https://dev-portals-images.s3.amazonaws.com/NOL/products/toallas.svg"}
             // src={info.detail[0].image}
             alt=""
        />

      </div>
      <div className="f-card-samples__description">
        <div className="f-card-samples__description__info">
          <h6 className="f-card-samples__description__info-name">{info.detail[0].name}</h6>
          <span className="f-card-samples__description__info-date">{FormatDate(info.orderDate)}</span>
        </div>
        {/*<div className="f-card-samples__description__points">*/}
        {/*  <span>0 puntos</span>*/}
        {/*</div>*/}
        <span className={"f-icon icon-down f-card-arrow " + (isShow ? "f-card-arrow-effect" : "")}></span>
      </div>
      <div className={`f-card-samples__description--mob ${isShow && "visible"}`}>
        {/*<div className='f-card-samples__description--mob-points'><span>Puntos</span> <span> 0 Puntos</span></div>*/}
        <div className='f-card-samples__description--mob-date'><span>Fecha ingreso</span> <span>{FormatDate(info.orderDate)}</span></div>
      </div>
    </div>
  )
}

export default CardSamples
